import React from 'react';
import { IProps } from './types';
import { InsType } from 'constants/enums/insType.enum';
import sweetAlertService from 'utils/sweetAlertService';
import { withRouter } from 'react-router-dom';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { RouterSettings } from 'constants/models/routerSettings';

const MainInsuranceItem: React.SFC<IProps> = (props) => {
  /**
   * @description 點選各商品後連結至其商品首頁。
   */
  const handleRedirectUrl = () => {
    switch (props.INS_TYPE_ID) {
      case InsType.Travel:
        props.history.push(RouterSettings.Product.TravelIns);
        break;
      case InsType.Car:
        props.history.push(RouterSettings.Product.CarIns);
        break;
      case InsType.Moto:
        props.history.push(RouterSettings.Product.MotoIns);
        break;
      case InsType.MobileDevice:
        props.history.push(RouterSettings.Product.MobileDeviceIns);
        break;
      case InsType.Fire:
        props.history.push(RouterSettings.Product.FireIns);
        break;
      case InsType.Pet:
        props.history.push(RouterSettings.Product.PetIns);
        break;
      case InsType.ECar:
        props.history.push(RouterSettings.Product.ECarIns);
        break;
      default:
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: `${props.INS_TYPE_NAME}商品建置中，敬請期待…`
        });
        break;
    }
  };

  /**
   * @description 格式化顯示訊息
  */
  const handleFormatNote = (note: string) => {
    if (note && note.indexOf(' ') !== -1) {
      const strArray = note.split(' ');
      return (
        <p>
          {strArray[0]} <br /> {strArray[1]}
        </p>
      );
    }

    return (
      <p>{note}</p>
    );
  };

  return (
    <>
      <div className={'main__insurance-item' + (props.INS_TYPE_ID === 'I07' ? ' new' : '')} onClick={handleRedirectUrl} onMouseOver={props.handleMouseOver}>
        {/* {props.INS_TYPE_ID === 'I07' && <span className="new" />} */}
        <div className="main__insurance-item-main">
          <h3>{props.INS_TYPE_NAME}</h3>
          <p>
            {props.BRIEF}
          </p>
        </div>
        <div className="main__insurance-item-info">
          {handleFormatNote(props.NOTE)}
        </div>
      </div>
    </>
  );
};

export default withRouter(MainInsuranceItem);
